var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', _vm._b({
    class: "texting-form-addresses-".concat(_vm.className),
    attrs: {
      "multiple": "",
      "item-value": "_application",
      "menuProps": {
        attach: ".texting-form-addresses-".concat(_vm.className)
      },
      "return-object": "",
      "small-chips": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.addressees,
      callback: function callback($$v) {
        _vm.addressees = $$v;
      },
      expression: "addressees"
    }
  }, 'v-autocomplete', Object.assign({}, _vm.$attrs, {
    items: _vm.items,
    itemText: _vm.itemText
  }), false));
}
var staticRenderFns = []

export { render, staticRenderFns }